import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import Tools from '../tools/tools';


const JobDocuments = (props) => {
    let [data, setData] = useState();
    let [fileModalVisible, setfileModalVisible] = useState(false);

    const fetchData = async () => {
        setData(null);
        Comm.Instance().get(`document?entity=job&id=${props.jobId}`).then(result => {
            setData(result.data);

        }).catch(error => Tools.ProcessError(error))
    };
    useEffect(() => {

        fetchData();
    }, []);

    const del = (documentId) => {
        Comm.Instance().delete(`document?entity=job&entityId=${props.jobId}&documentId=${documentId}`).then(result => {

            fetchData();
        }).catch(error => Tools.ProcessError(error))
    }

    const addConnection = (documentId) => {
        setfileModalVisible(false);
        if (!documentId)
            return;
        let data = {
            documentId: documentId,
            entityId: parseInt(props.jobId)
        };
        console.log("data", data);
        Comm.Instance().put(`document?entity=job`, data).then(result => {

            fetchData();
        }).catch(error => Tools.ProcessError(error))
    }




    if (!data)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!data}
                />
            </div>
        );
    return (
        <>
            <div className="container">
                
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        Документ
                                    </th>
                                    <th>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.map(i =>
                                        <tr key={i.documentId}>
                                            <td>
                                                <a href={'documentcontent?documentId=' + i.documentId} title={i.remark} alt={i.remark}>{i.title}</a>

                                            </td>
                                            <td>
                                                <button className="btn btn-danger" onClick={() => del(i.documentId)}>Премахване</button>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="container">
                <button type="button" className="btn btn-primary" onClick={() => setfileModalVisible(true)}>Нов документ</button>
            </div>
            <ModalUpload display={fileModalVisible} closeFunc={(val) => addConnection(val)} />
        </>

    );
}


export default JobDocuments;

